<div class="snack-bar-content" matSnackBarLabel>
  <div class="snack-bar-message">
    <strong>Process Error</strong>
    <p>The process could not be completed. Please check your connection and try again.</p>
  </div>
</div>
<div class="snack-bar-actions" matSnackBarActions>
  <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">
    Retry
  </button>
  <mat-icon matSnackBarAction (click)="snackBarRef.dismiss()">close</mat-icon>
</div>
